export default "__VITE_ASSET__CKkTvqzH__"